var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOilTank = function SvgOilTank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 510 510"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285 210h75v45h-75zM285 135h75v45h-75zM180 60V30h30V0H45v30h30v30C33.644 60 0 93.645 0 135v180c0 36.22 25.809 66.522 60 73.491V435h90v-45h105V60zM285 60h75v45h-75zM435 60h-45v330h-30v45h90v-46.509c34.192-6.969 60-37.272 60-73.491V135c0-41.355-33.645-75-75-75M285 360h75v30h-75zM285 285h75v45h-75zM255 30h30v30h-30zM255 390h30v45h-30zM360 30h30v30h-30zM0 465h510v45H0z"
  })));
};
export default SvgOilTank;